import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { initTidio } from '@/plugins/tidio'
import './index.css'

createApp(App).use(router).mount('#app')

initTidio()
